import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import NoticeList from './NoticeList';
import NoticeDetail from './NoticeDetail';

@inject(({ commonStore, boardStore }) => ({
  commonStore: commonStore,
  sessionLoginInfo: commonStore.sessionLoginInfo,
  setCommonStoreInfo: boardStore.setCommonStoreInfo,
  
  onClear: boardStore.onClear,
  viewMode: boardStore.viewMode,
  onViewMode: boardStore.onViewMode,
  valCondition: boardStore.valCondition,
  noticeList: boardStore.noticeList,
  pageInfo: boardStore.pageInfo,
  detailData: boardStore.detailData,
  onChangValue: boardStore.onChangValue,
  disNoticeDetail: boardStore.disNoticeDetail,
  disNoticeList: boardStore.disNoticeList,
  addNoticeInfo: boardStore.addNoticeInfo,
  modNoticeInfo: boardStore.modNoticeInfo,
  delNoticeInfo: boardStore.delNoticeInfo,
}))
@observer
class NoticeContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disNoticeList(1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/notice');
      } else {
        this.props.history.push('/notice/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { 
      viewMode,
      valCondition,
      noticeList,
      pageInfo,
      detailData,

      onChangValue,
      onViewMode, 
      disNoticeDetail, 
      disNoticeList,
      addNoticeInfo,
      modNoticeInfo,
      delNoticeInfo,

      sessionLoginInfo
    } = this.props;
    return (
      <Fragment>
        {viewMode === 'list'
        ? <NoticeList
            viewMode={viewMode}
            noticeList={noticeList}
            pageInfo={pageInfo}
            valCondition={valCondition}
            onChangValue={(dataNm, dataVal)=>onChangValue(dataNm, dataVal)}
            onViewMode={(mode)=>onViewMode(mode)}
            disNoticeDetail={(id)=>disNoticeDetail(id)}
            disNoticeList={(pageIdx)=>disNoticeList(pageIdx)}
            delNoticeInfo={delNoticeInfo}
            sessionLoginInfo={sessionLoginInfo}
          /> 
        : <NoticeDetail
            viewMode={viewMode}
            detailData={detailData}
            onViewMode={(mode)=>onViewMode(mode)}
            disNoticeDetail={(id)=>disNoticeDetail(id)}
            addNoticeInfo={(data)=>addNoticeInfo(data)}
            modNoticeInfo={(data)=>modNoticeInfo(data)}
            disNoticeList={(pageIdx)=>disNoticeList(pageIdx)}
            delNoticeInfo={delNoticeInfo}
            sessionLoginInfo={sessionLoginInfo}
          />
        }
      </Fragment>
    );
  }

}

export default withRouter(NoticeContainer);
